export default (error, code = 422) => error && error.code === code;
